function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.80005 19.6004C2.80005 13.4148 7.81446 8.40039 14 8.40039V8.40039C20.1856 8.40039 25.2 13.4148 25.2 19.6004V22.4004H2.80005V19.6004Z",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2 11.2002C25.2 11.2002 25.2 9.80019 23.8001 8.40019C22.4001 7.0002 19.6 7.0002 19.6 7.0002C19.6 7.0002 18.1449 4.2002 14 4.2002C9.85517 4.2002 8.40005 7.0002 8.40005 7.0002C8.40005 7.0002 5.60005 7.0002 4.20005 8.40019C2.80005 9.80019 2.80005 11.2002 2.80005 11.2002",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14 11.9004L13.3 14.0004",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.69995 14.7002L8.39995 16.8002",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9999 17.5004L14.6999 19.6004",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9999 14.7002L19.5999 16.8002",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var SvgTacos = function SvgTacos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTacos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tacos.9eec1a85.svg";
export { ForwardRef as ReactComponent };